import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'
import { Link, useNavigate } from "react-router-dom"

import Navbar from '../elements/Navbar'
import Footer from '../elements/Footer'
import FeedbackForm from '../elements/FeedbackForm'

const Home = (props) => {

    useEffect(() => {
        window.scrollTo(0,0);
    },[])

    useEffect(() => {
        document.title = 'AutoVitus - Feedback'
    }, []);

    return (
        <div className='center' style={{width: '99.1vw', height: 'auto', backgroundColor: 'white', display: 'flex', flexDirection: 'column', overflowX: 'hidden'}}>
            <div style={{margin: 'auto', height: '100%', maxWidth: '1500px', width: '100%'}}>
                <Navbar></Navbar>
                <FeedbackForm style={{marginTop: '50px'}}></FeedbackForm>
                <Footer style={{marginTop: '150px'}}></Footer>
            </div>
        </div>
    )
}

export default Home
